import React, { useEffect, useState } from "react";
import {
  IconButton,
  Badge,
  Popover,
  Box,
  Typography,
  Divider,
  Button,
  Skeleton,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNotifications } from "context/NotificationContext";
import NotificationItem from "components/NotificationItem";

function NotificationBell() {
  const { unreadCount, notifications, isLoading, fetchNotifications, limit } = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);
  const [localNotifications, setLocalNotifications] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl) {
      fetchNotifications(5, 0, "all");
    }
  }, [anchorEl, fetchNotifications]);

  useEffect(() => {
    setLocalNotifications(notifications.slice(0, 3));
  }, [notifications]);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleClick}
        aria-describedby="notification-popover"
        sx={{ position: "relative" }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#ff5252",
              color: "#ff5252",
              boxShadow: `0 0 0 2px #fff`,
            },
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        id="notification-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: { backgroundColor: "#ffffff", boxShadow: 3 },
        }}
      >
        <Box sx={{ width: 360, maxHeight: 500, overflow: "auto", backgroundColor: "#ffffff" }}>
          <Box sx={{ p: 2, backgroundColor: "#ffffff", borderBottom: "1px solid #eee" }}>
            <Typography variant="h6">Notifications</Typography>
          </Box>

          {isLoading ? (
            <Box sx={{ p: 2 }}>
              <Skeleton variant="rectangular" height={60} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={60} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={60} />
            </Box>
          ) : localNotifications.length === 0 ? (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography color="textSecondary">No notifications</Typography>
            </Box>
          ) : (
            <Box>
              {localNotifications.map((notification) => (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  onClose={handleClose}
                />
              ))}
            </Box>
          )}

          <Box
            sx={{
              p: 2,
              textAlign: "center",
              borderTop: "1px solid #eee",
              backgroundColor: "#ffffff",
            }}
          >
            <Button size="small" color="primary" href="/notifications" onClick={handleClose}>
              View All Notifications
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}

export default NotificationBell;
